import { AssignmentTurnedIn as TaskIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useStore } from '@priolo/jon';
import PlaceholderCmp, { ICON_TYPE } from 'components/controls/PlaceholderCmp';
import DrawerCmp from 'components/controls/drawer/DrawerCmp';
import { TAGS } from 'components/planner/types';
import { filterActivitiesByTags, getActivityFromGroups } from 'components/planner/utils';
import SearchFiltersUrl from 'components/search/SearchFiltersUrl';
import TasksList from 'pages/farms/tasks/list/TasksList';
import { useMemo } from 'react';
import plannerSo from "stores/planner";
import { updatePlannerTasks } from 'stores/planner/utils/update';
import querySo from "stores/route/query";
import { URL_PAR } from 'stores/route/utils/types';
import taskSo from "stores/task";
import detailSo from "stores/task/taskDetail";
import { getTaskFiltered, groupTasksByDate } from 'stores/task/utils';
import { Cycle } from 'types/Cycle';
import { Task } from 'types/Task';
import { urlToDateRange } from 'utils';
import SelectorScopeAndGroupH from './SelectorScopeAndGroupH';



/**
 * Il DROWER che appare a destra del GANTT contentne tutti i TASKS selezionati
 */
function TasksDrawer() {

	// STORE
	const taskSa = useStore(taskSo)
	const plannerSa = useStore(plannerSo)
	useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleCloseDrawer = () => plannerSo.setIsTaskDrawerOpen(false)
	const handleTaskSelect = async (task: Task) => {
		const save = await detailSo.open({ task })
		if (!save) return
		updatePlannerTasks()
	}
	const handleCycleMouseOver = (cycle: Cycle, e) => {
		if (cycleSel) return
		let actsHighlight = null
		if (cycle) {
			const activities = getActivityFromGroups(plannerSo.state.groups)
			actsHighlight = filterActivitiesByTags(activities, { cycles: [cycle.cycleUuid] })
		}
		plannerSo.setHighlight(actsHighlight)
	}
	

	// RENDER
	const [cycleSel, growUnitSel, scopeSel, groupSel, txtSearch, dateSel] = querySo.getSearchUrl([
		URL_PAR.CYCLE_SEL, URL_PAR.GROWUNIT_SEL, URL_PAR.SCOPE_FIL,
		URL_PAR.SCOPE_GROUP_FIL, URL_PAR.TEXT, URL_PAR.DATE_SEL
	])

	const groups = useMemo(() => {
		if (!plannerSa.isTaskDrawerOpen || (!cycleSel && !dateSel)) return []
		const dateRange = !cycleSel ? urlToDateRange(dateSel) : null
		return groupTasksByDate(getTaskFiltered(taskSa.all, +growUnitSel, scopeSel, groupSel, cycleSel, dateRange, txtSearch))
	}, [taskSa.all, plannerSa.isTaskDrawerOpen, plannerSa.groups, cycleSel, growUnitSel, scopeSel, groupSel, txtSearch, dateSel])

	const cycleUuidHighlight = useMemo(() => {
		if (!plannerSa.highlight || plannerSa.highlight.length == 0 || cycleSel) return null
		return plannerSa.highlight[0].tags?.[TAGS.CYCLES]?.[0]
	}, [plannerSa.highlight, cycleSel])

	return <DrawerCmp
		icon={<TaskIcon />}
		title={"TASKS"}
		open={plannerSa.isTaskDrawerOpen}
		onClose={handleCloseDrawer}
		renderHeader={<Box sx={{ display: "flex", alignItems: "center" }}>
			<SearchFiltersUrl sx={{ flex: 1 }} />
			<SelectorScopeAndGroupH />
		</Box>}
	>
		{groups?.length > 0 ? <TasksList
			groups={groups}
			cycleUuidHighlight={cycleUuidHighlight}
			onClickTask={handleTaskSelect}
			onCycleMouseOver={handleCycleMouseOver}
		/> : <PlaceholderCmp
			title="THERE ARE NO TASKS"
			subtitle="try changing the filter settings"
			iconType={ICON_TYPE.VOID}
		/>}
	</DrawerCmp>
}

export default TasksDrawer
